"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var EventKind;
(function (EventKind) {
    EventKind[EventKind["Unknown"] = -1] = "Unknown";
    EventKind[EventKind["SetMetadata"] = 0] = "SetMetadata";
    EventKind[EventKind["TextNote"] = 1] = "TextNote";
    EventKind[EventKind["RecommendServer"] = 2] = "RecommendServer";
    EventKind[EventKind["ContactList"] = 3] = "ContactList";
    EventKind[EventKind["DirectMessage"] = 4] = "DirectMessage";
    EventKind[EventKind["Deletion"] = 5] = "Deletion";
    EventKind[EventKind["Repost"] = 6] = "Repost";
    EventKind[EventKind["Reaction"] = 7] = "Reaction";
    EventKind[EventKind["BadgeAward"] = 8] = "BadgeAward";
    EventKind[EventKind["SimpleChatMessage"] = 9] = "SimpleChatMessage";
    EventKind[EventKind["SnortSubscriptions"] = 1000] = "SnortSubscriptions";
    EventKind[EventKind["Polls"] = 6969] = "Polls";
    EventKind[EventKind["GiftWrap"] = 1059] = "GiftWrap";
    EventKind[EventKind["FileHeader"] = 1063] = "FileHeader";
    EventKind[EventKind["Relays"] = 10002] = "Relays";
    EventKind[EventKind["Ephemeral"] = 20000] = "Ephemeral";
    EventKind[EventKind["Auth"] = 22242] = "Auth";
    EventKind[EventKind["PubkeyLists"] = 30000] = "PubkeyLists";
    EventKind[EventKind["NoteLists"] = 30001] = "NoteLists";
    EventKind[EventKind["TagLists"] = 30002] = "TagLists";
    EventKind[EventKind["Badge"] = 30009] = "Badge";
    EventKind[EventKind["ProfileBadges"] = 30008] = "ProfileBadges";
    EventKind[EventKind["LiveEvent"] = 30311] = "LiveEvent";
    EventKind[EventKind["ZapstrTrack"] = 31337] = "ZapstrTrack";
    EventKind[EventKind["SimpleChatMetadata"] = 39000] = "SimpleChatMetadata";
    EventKind[EventKind["ZapRequest"] = 9734] = "ZapRequest";
    EventKind[EventKind["ZapReceipt"] = 9735] = "ZapReceipt";
    EventKind[EventKind["HttpAuthentication"] = 27235] = "HttpAuthentication";
})(EventKind || (EventKind = {}));
exports.default = EventKind;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZXZlbnQta2luZC5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uL3NyYy9ldmVudC1raW5kLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7O0FBQUEsSUFBSyxTQThCSjtBQTlCRCxXQUFLLFNBQVM7SUFDWixnREFBWSxDQUFBO0lBQ1osdURBQWUsQ0FBQTtJQUNmLGlEQUFZLENBQUE7SUFDWiwrREFBbUIsQ0FBQTtJQUNuQix1REFBZSxDQUFBO0lBQ2YsMkRBQWlCLENBQUE7SUFDakIsaURBQVksQ0FBQTtJQUNaLDZDQUFVLENBQUE7SUFDVixpREFBWSxDQUFBO0lBQ1oscURBQWMsQ0FBQTtJQUNkLG1FQUFxQixDQUFBO0lBQ3JCLHdFQUF5QixDQUFBO0lBQ3pCLDhDQUFZLENBQUE7SUFDWixvREFBZSxDQUFBO0lBQ2Ysd0RBQWlCLENBQUE7SUFDakIsaURBQWMsQ0FBQTtJQUNkLHVEQUFrQixDQUFBO0lBQ2xCLDZDQUFZLENBQUE7SUFDWiwyREFBbUIsQ0FBQTtJQUNuQix1REFBaUIsQ0FBQTtJQUNqQixxREFBZ0IsQ0FBQTtJQUNoQiwrQ0FBYSxDQUFBO0lBQ2IsK0RBQXFCLENBQUE7SUFDckIsdURBQWlCLENBQUE7SUFDakIsMkRBQW1CLENBQUE7SUFDbkIseUVBQTJCLENBQUE7SUFDM0Isd0RBQWlCLENBQUE7SUFDakIsd0RBQWlCLENBQUE7SUFDakIseUVBQTBCLENBQUE7QUFDNUIsQ0FBQyxFQTlCSSxTQUFTLEtBQVQsU0FBUyxRQThCYjtBQUVELGtCQUFlLFNBQVMsQ0FBQyJ9